// eslint-disable-next-line import/no-cycle
import { getTenantCustomTagList } from '@/api/domain/others'

// 司机
const customer = {
  state: {
    tags: [],
  },
  mutations: {
    SET_TAGS: (state, tags) => {
      state.tags = tags
    },
  },
  actions: {
    getTags({ commit }) {
      return new Promise((resolve, reject) => {
        getTenantCustomTagList({ type: 2 }).then((res) => {
          const { code, data } = res
          if (code === 1) {
            resolve(data)
            commit('SET_TAGS', data)
          }
        }).catch((err) => {
          reject(err)
        })
      })
    },
  },
}

export default customer
